// SideCart.js

import React, { useState, useEffect, useRef } from "react";
import Client from "shopify-buy";
export default function SideCart({ isOpen, onClose, cartItems }) {
  const [variantId, setVariantId] = useState(null);
  const [variantAvailable, setVariantAvailable] = useState(false);
  const [selectedColor, setSelectedColor] = useState("");
  const [product, setProduct] = useState(null);
  const [colorOptions, setColorOptions] = useState([]);
  // 初始化 Shopify 客户端
  const shopifyClient = Client.buildClient({
    domain: "shop.likkim.com",
    storefrontAccessToken: "3e4c4a173b156be8292ffba6392a486c",
  });
  const handleCheckout = async () => {
    if (cartItems.length === 0) {
      alert("Cart is empty.");
      return;
    }

    try {
      const checkout = await shopifyClient.checkout.create();

      const lineItems = cartItems.map((item) => ({
        variantId: item.variantId || variantId, // 如果没传入就用默认
        quantity: 1,
        properties: {
          color: item.color || selectedColor,
        },
      }));

      const updatedCheckout = await shopifyClient.checkout.addLineItems(
        checkout.id,
        lineItems
      );

      window.location.href = updatedCheckout.webUrl;
    } catch (error) {
      console.error("Checkout Error:", error);
      alert("Checkout failed. Please try again.");
    }
  };

  useEffect(() => {
    shopifyClient.product
      .fetchByHandle("LIKKIM")
      .then((product) => {
        console.log("Variants:", product.variants);
        if (product.variants && product.variants.length > 0) {
          const firstVariant = product.variants[0];
          setVariantId(firstVariant.id);
          setVariantAvailable(firstVariant.available);

          // Collect color options
          const colors = [];
          product.variants.forEach((variant) => {
            // Assuming color is in selectedOptions
            const colorOption = variant.selectedOptions.find(
              (option) => option.name.toLowerCase() === "color"
            );

            if (colorOption) {
              colors.push(colorOption.value);
            } else {
              console.log("No color option found");
            }
          });

          setColorOptions(colors);
          setProduct(product); // Store product data in state
        } else {
          console.log("No variants found for this product.");
        }
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  }, []);

  return (
    <div
      className={`fixed top-0 right-0 h-full bg-white z-50 shadow-lg transform transition-transform duration-300 ease-in-out
      ${isOpen ? "translate-x-0" : "translate-x-full"} 
      w-[600px] sm:w-full`}
    >
      <div className="p-6 flex flex-col h-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Review your cart</h2>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="flex-1 overflow-y-auto">
          {cartItems.length === 0 ? (
            <p className="text-center text-gray-500">Your cart is empty.</p>
          ) : (
            cartItems.map((item, index) => (
              <div key={index} className="flex justify-between py-2 border-b">
                <span>{item.name}</span>
                <span>¥{item.price.toLocaleString()}</span>
              </div>
            ))
          )}
        </div>

        <div className="mt-6">
          <div className="flex justify-between text-lg font-semibold">
            <span>Total</span>
            <span>
              ¥
              {cartItems
                .reduce((acc, item) => acc + item.price, 0)
                .toLocaleString()}
            </span>
          </div>
          <button
            onClick={handleCheckout}
            className="mt-4 w-full bg-black text-white py-3 rounded-full"
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
}
